// @flow
export const BUBBLE_THEME_API = {
  root: '',
  bubble: '',
  openUpward: '',
  transparent: '',
  isFloating: '',
  isHidden: ''
};
